import CompetencyMatrixComp from '../../Components/CompetencyMatrix/CompetencyMatrixComp';

function CompetencyMatrix() {
  return <CompetencyMatrixComp />;
}

export default CompetencyMatrix;
